<div class="form-container service-form {{ formName }} ms-large-t" #formContainer>
  <!-- Initial form state -->
  <form
    *ngIf="formStatus === FormStatus.INITIAL || formStatus === FormStatus.ERROR"
    [formGroup]="reactiveForm"
    (ngSubmit)="onSubmit()"
    [finFormErrorFocus]="reactiveForm"
  >
    <!-- Error notification -->
    <fcom-notification
      *ngIf="formStatus === FormStatus.ERROR"
      class="mr-medium-b"
      [layout]="NotificationLayout.BLOCK"
      [theme]="NotificationTheme.ALERT"
    >
      {{ translationPrefix + '.error.title' | finLocalization }}
    </fcom-notification>
    <p class="font-body-1 nordic-blue-900-text pr-medium-t" data-testid="mandatory-fields">
      {{ translationNamespace + '.mandatoryFields' | finLocalization }}
    </p>
    <div
      class="flex flex--row flex--wrap flex--space-between form-subgroup"
      *ngFor="let group of controlConfig"
      [formGroupName]="group.controlName"
    >
      <ng-container *ngFor="let field of group.fields">
        <ng-container [ngSwitch]="field.type">
          <fcom-text-input
            *ngSwitchCase="FormBuilderInput.TEXT"
            [parentForm]="reactiveForm.controls[group.controlName]"
            [controlName]="field.controlName"
            [translationPrefix]="field.translationPrefix"
            [placeHolder]="field.placeHolder"
          >
          </fcom-text-input>
          <div class="flex flex--basis-full full-width form-subgroup" *ngSwitchCase="FormBuilderInput.TEXTAREA">
            <fcom-text-input
              #textarea
              [parentForm]="reactiveForm.controls[group.controlName]"
              [controlName]="field.controlName"
              [translationPrefix]="field.translationPrefix"
              [placeHolder]="field.placeHolder"
              [type]="TextInputType.TEXTAREA"
              [characterLimit]="field.wordCount"
              [characterCount]="textarea.control?.value?.length || 0"
            >
            </fcom-text-input>
          </div>
          <div class="flex flex--basis-full form-subgroup unstyled" *ngSwitchCase="FormBuilderInput.FILE_UPLOADER">
            <fcom-file-uploader
              class="mr-large-b"
              [allowedFileTypes]="field.allowedFileTypes || defaultAllowedFileTypes"
              [customAttachLabel]="field.customAttachLabel"
              [customRequiredLabel]="field.customRequiredLabel"
              [controlName]="field.controlName"
              [disabled]="field.disabled"
              [id]="field.id"
              [i18n]="field.i18n || 'SERVICE_FORMS.serviceForms.fields.fileUploader' | finLocalization"
              [maxAttachments]="field.maxAttachments || defaultMaxAttachments"
              [maxSizeInBytes]="field.maxSizeInBytes || defaultMaxSizeInBytes"
              [parentForm]="reactiveForm.controls[group.controlName]"
              [uploadService]="field.uploadService"
              #fileUploader
            ></fcom-file-uploader>
          </div>
          <fin-select-input
            *ngSwitchCase="FormBuilderInput.SELECT"
            [parentForm]="reactiveForm.controls[group.controlName]"
            [controlName]="field.controlName"
            [translationPrefix]="field.translationPrefix"
            [options]="field.options"
          >
          </fin-select-input>
          <fcom-radio-item-group
            *ngSwitchCase="FormBuilderInput.RADIO"
            [id]="field.controlName"
            [options]="field.values"
            [parentForm]="reactiveForm.controls[group.controlName]"
            [controlName]="field.controlName"
            [translationPrefix]="field.translationPrefix"
          >
          </fcom-radio-item-group>
        </ng-container>
        <div *ngIf="field.note" class="flex flex--basis-full full-width ms-large-b">
          <span class="block font-body-1">
            {{ field.note | finLocalization }}
          </span>
        </div>
      </ng-container>
    </div>

    <div class="ps-small-t align-right">
      <fcom-button
        data-testid="submit-button"
        [type]="ButtonType.SUBMIT"
        [text]="translationPrefix + '.submit' | finLocalization"
      ></fcom-button>
    </div>
  </form>
  <!-- While sending -->
  <div *ngIf="formStatus === FormStatus.LOADING" class="relative loader">
    <fin-loader [type]="LoaderType.INLINE"></fin-loader>
  </div>
  <!-- Success view -->
  <div *ngIf="formStatus === FormStatus.COMPLETE">
    <h2>{{ translationPrefix + '.success.title' | finLocalization }}</h2>
    <p *ngIf="hasSuccessMessage">{{ translationPrefix + '.success.message' | finLocalization }}</p>
  </div>
</div>
